import React, { useMemo } from "react";
import Pagination from "../../../../components/Pagination/Pagination";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetProtectedApiDataQuery } from "../../../../redux/services/apiSlice";
import usePagination from "../../../../hooks/usePagination";
import { extractDate } from "../../../../Utils/utils";
import Loader from "../../../../components/Loader";
import PageLastUpdated from "../../../../components/shared/PageLastUpdated";
import PhotoGalleryCoverCard from "./PhotoGalleryCoverCard";

const PhotoGalleryDetail = () => {
  const { languageType } = useSelector((state) => state.homeSlice);

  const navigate = useNavigate();

  const { data: photosGalleryData = [], isLoading: photosGalleryIsLoading } =
    useGetProtectedApiDataQuery({ url: "photo_gallery", lang: languageType });

  const handlePhotoClick = (nid) => {
    navigate(`/photo-gallery-detail/${nid}`);
  };
  const { currentItems, currentPage, totalPages, handlePageChange } =
    usePagination(photosGalleryData, 12);

  console.log({ galleryItems: currentItems });

  const lastUpdatedOn = useMemo(() => {
    return extractDate(photosGalleryData?.[0]);
  }, [photosGalleryData]);

  if (photosGalleryIsLoading) {
    return <Loader />;
  }
  return (
    <>
      <div className="row">
        <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />

        {currentItems.map((item) => (
          <PhotoGalleryCoverCard photoGalleryItem={item} />
          // <div
          //   className="col-12 col-sm-12 col-md-3 col-lg-3 mvDescWrap"
          //   key={item.nid}
          // >
          //   <div className="photo-gallery-area desc-sec photo-gallery-detail-page">
          //     <div className="card-sec">
          //       <div
          //         className="img-sec"
          //         onClick={() => handlePhotoClick(item.nid)}
          //       >
          //         <img
          //           src={`${process.env.REACT_APP_IMAGE_URL}/${item?.field_image_media}`}
          //           alt={item.title}
          //         />
          //       </div>
          //       <div className="desc-sec">
          //         <p>{item.title.slice(0, 70)}</p>
          //       </div>
          //     </div>
          //   </div>
          // </div>
        ))}
      </div>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </>
  );
};

export default PhotoGalleryDetail;
